import React from 'react';
import './ServicesPage.css';

function ServicesPage() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">How can we help?</h1>
            <p className="hero-description">
              We offer sports flooring for all major sports like <span className="highlight">Badminton</span>, <span className="highlight">Tennis</span>, <span className="highlight">Cricket</span>, <span className="highlight">Football</span>, <span className="highlight">Basketball</span>, <span className="highlight">Volleyball</span>, <span className="highlight">Handball</span>, <span className="highlight">Netball</span>, <span className="highlight">Squash</span>, <span className="highlight">Skating</span>, <span className="highlight">Athletics</span>, <span className="highlight">Futsal</span>, <span className="highlight">Pickleball</span> etc.
            </p>
            <div className="motto-section">
              <h2 className="motto-title">
                We are a <span className="accent">one-stop shop</span> for all your <span className="accent">sports infra requirements</span>.
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {/* Turnkey Sports Infrastructure Development */}
            <div className="service-card turnkey" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Turnkey Sports Infra Development</h3>
              </div>
            </div>

            {/* Project Consultation */}
            <div className="service-card consultation" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Project Consultation</h3>
              </div>
            </div>

            {/* Sports Flooring Solutions */}
            <div className="service-card flooring" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Flooring Solutions</h3>
              </div>
            </div>

            {/* Sports Consultancy */}
            <div className="service-card consultancy" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Consultancy</h3>
              </div>
            </div>

            {/* Ground Development */}
            <div className="service-card ground-dev" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Ground Development (Sports Infra Developer)</h3>
              </div>
            </div>

            {/* Physiology */}
            <div className="service-card physiology" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Physiology</h3>
              </div>
            </div>

            {/* Games Section */}
            <div className="service-card games-section" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=800&h=600&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="games-content">
                <div className="games-header">
                  <h3 className="games-title">SPORTS & GAMES</h3>
                  <p className="games-subtitle">Professional Training & Coaching</p>
                </div>
                <div className="games-showcase">
                  <div className="featured-games">
                    <div className="featured-game" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=300&h=200&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="featured-overlay"></div>
                      <div className="featured-content">
                        <span className="featured-name">BADMINTON</span>
                        <span className="featured-desc">Professional Training</span>
                      </div>
                    </div>
                    <div className="featured-game" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=300&h=200&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="featured-overlay"></div>
                      <div className="featured-content">
                        <span className="featured-name">TABLE TENNIS</span>
                        <span className="featured-desc">Expert Coaching</span>
                      </div>
                    </div>
                    <div className="featured-game" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1546519638-68e109498ffc?w=300&h=200&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="featured-overlay"></div>
                      <div className="featured-content">
                        <span className="featured-name">BASKETBALL</span>
                        <span className="featured-desc">Team Development</span>
                      </div>
                    </div>
                    <div className="featured-game" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=300&h=200&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="featured-overlay"></div>
                      <div className="featured-content">
                        <span className="featured-name">VOLLEYBALL</span>
                        <span className="featured-desc">Team Sports</span>
                      </div>
                    </div>
                  </div>
                  <div className="all-games-grid">
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">TENNIS</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">ATHLETICS</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">BOXING</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">WEIGHTLIFTING</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">POWERLIFTING</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">VOLLEYBALL</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">CRICKET</span>
                    </div>
                    <div className="mini-game-item" style={{
                      backgroundImage: 'url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=150&h=100&fit=crop&crop=center)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}>
                      <div className="mini-overlay"></div>
                      <span className="mini-name">SHOOTING</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Admission */}
            <div className="service-card admission" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Admission</h3>
                <div className="service-subcategories">
                  <div className="subcategory-item">
                    <span className="subcategory-text">School</span>
                  </div>
                  <div className="subcategory-item">
                    <span className="subcategory-text">College</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Scholarship */}
            <div className="service-card scholarship" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Scholarship</h3>
              </div>
            </div>

            {/* Coaches */}
            <div className="service-card coaches" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Coaches</h3>
                <p className="service-description">Dynamic platform where coaches can showcase their work, experience, and coaching areas</p>
              </div>
            </div>

            {/* Physiotherapy */}
            <div className="service-card physiotherapy" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Physiotherapy</h3>
              </div>
            </div>

            {/* Recruitment and Jobs */}
            <div className="service-card recruitment" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Recruitment and Jobs</h3>
              </div>
            </div>

            {/* Dietician */}
            <div className="service-card dietician" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=600&h=400&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Dietician</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Flooring Products Section */}
      <section className="flooring-products-section">
        <div className="container">
          <h2 className="section-title">Sports Flooring Products</h2>
          <div className="products-grid">
            {/* Volleyball Court Construction */}
            <div className="product-card volleyball">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=100&h=100&fit=crop&crop=center" alt="Volleyball" />
                </div>
                <h3 className="product-title">Volleyball Court Construction</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Elite International Sports are Volleyball Court Builders in India. We provide flooring options for both Indoor and Outdoor Courts.
                </p>
                <div className="product-specs">
                  <h4 className="specs-title">Court Specifications:</h4>
                  <ul className="specs-list">
                    <li>18 meters long and 9 meters wide</li>
                    <li>Net height: 2.43m (men) / 2.24m (women)</li>
                    <li>Divided into two 9m x 9m halves</li>
                  </ul>
                </div>
                <div className="flooring-options">
                  <h4 className="options-title">Available Surfaces:</h4>
                  <div className="options-grid">
                    <span className="option-item">Air-Cush Wooden Flooring</span>
                    <span className="option-item">Outdoor Synthetic Surface</span>
                    <span className="option-item">Indoor PVC Vinyl Flooring</span>
                    <span className="option-item">Rubber Flooring</span>
                    <span className="option-item">PP Tiles</span>
                    <span className="option-item">Artificial Grass</span>
                    <span className="option-item">Natural</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Cricket Pitch Construction */}
            <div className="product-card cricket">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=100&h=100&fit=crop&crop=center" alt="Cricket" />
                </div>
                <h3 className="product-title">Cricket Pitch Construction</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Cricket Pitch is a natural product that needs to be handled with great care. We carefully assess what's required, adapting our construction techniques to deliver high-performance pitches.
                </p>
                <div className="construction-steps">
                  <h4 className="steps-title">Construction Process:</h4>
                  <div className="steps-list">
                    <div className="step-item">
                      <span className="step-number">1</span>
                      <span className="step-text">Excavate for Pitch Formation</span>
                    </div>
                    <div className="step-item">
                      <span className="step-number">2</span>
                      <span className="step-text">Levelling and Consolidation</span>
                    </div>
                    <div className="step-item">
                      <span className="step-number">3</span>
                      <span className="step-text">Prepare Final Surface and Seed</span>
                    </div>
                  </div>
                </div>
                <div className="pitch-types">
                  <h4 className="types-title">Pitch Types:</h4>
                  <div className="types-grid">
                    <span className="type-item">Natural Grass</span>
                    <span className="type-item">Artificial Turf</span>
                    <span className="type-item">Hybrid Systems</span>
                  </div>
                </div>
              </div>
            </div>

            {/* PP Interlocking Tiles */}
            <div className="product-card pp-tiles">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center" alt="PP Tiles" />
                </div>
                <h3 className="product-title">PP Interlocking Tiles</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Polypropylene Interlocking Suspended Modular Tiles - New Age Sports flooring, revolutionary, designed to eliminate traditional flooring cons, suitable for both indoor and outdoor applications.
                </p>
                <div className="features-grid">
                  <div className="feature-column">
                    <h4 className="features-title">Key Features:</h4>
                    <ul className="features-list">
                      <li>Environmentally friendly recyclable PP-composite</li>
                      <li>UV and Color stabilized for all weather</li>
                      <li>FDA approved - No emissions (No PVC)</li>
                      <li>Ergonomic - good for joints and backs</li>
                      <li>Correct bounce across the whole court</li>
                      <li>Extremely durable</li>
                      <li>Excellent drainage capability</li>
                      <li>Long warranty of 8 years</li>
                    </ul>
                  </div>
                  <div className="feature-column">
                    <h4 className="features-title">Additional Benefits:</h4>
                    <ul className="features-list">
                      <li>Expansion strips for longer lifespan</li>
                      <li>100% recyclable raw materials</li>
                      <li>Multiple colors available</li>
                      <li>Easy to install and uninstall</li>
                      <li>Tiles can be moved easily</li>
                      <li>Very low maintenance</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* EPDM Flooring */}
            <div className="product-card epdm">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop&crop=center" alt="EPDM Flooring" />
                </div>
                <h3 className="product-title">EPDM Flooring</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  EPDM (ethylene propylene diene monomer) rubber is synthetic and is used for various purposes including playground surfaces, Jogging Track, and sports flooring. It is safe and non-toxic, making it great for children's playgrounds.
                </p>
                <div className="epdm-features">
                  <h4 className="epdm-title">Main Features:</h4>
                  <div className="epdm-grid">
                    <span className="epdm-feature">Resistance to UV exposure</span>
                    <span className="epdm-feature">Resistance to extreme weather</span>
                    <span className="epdm-feature">Stable in low and high temperatures</span>
                    <span className="epdm-feature">Waterproof and effective drainage</span>
                    <span className="epdm-feature">Low electrical conductivity</span>
                    <span className="epdm-feature">Won't become brittle over time</span>
                    <span className="epdm-feature">Cushioning to guard against falls</span>
                    <span className="epdm-feature">Absorbs noise</span>
                    <span className="epdm-feature">Multiple stylish color choices</span>
                    <span className="epdm-feature">Easy to clean</span>
                    <span className="epdm-feature">Cost-effective material</span>
                    <span className="epdm-feature">Eco-friendly, often recycled materials</span>
                  </div>
                </div>
              </div>
            </div>

            {/* EVA Kabaddi Mat */}
            <div className="product-card eva-mat">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=100&h=100&fit=crop&crop=center" alt="EVA Mat" />
                </div>
                <h3 className="product-title">EVA Kabaddi Mat</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Made of EVA close-cell foam, with good anti-slippery patterns, durable, superior shock absorption, easy to clean and water resistant, high standard for kabaddi to avoid injuries while playing.
                </p>
                <div className="eva-advantages">
                  <h4 className="eva-title">Product Advantages:</h4>
                  <ul className="eva-list">
                    <li>Easy to assemble, anti slippery, stain resistant</li>
                    <li>Border strips water proof, tough top surface</li>
                    <li>Color choices available as per requirement</li>
                    <li>Made from non-toxic Material, durable, light weight</li>
                    <li>High density EVA foam</li>
                    <li>All tiles are waterproof and easily cleanable</li>
                    <li>Provides cushion to hard floor surfaces</li>
                    <li>Life: 8 to 10 Years</li>
                  </ul>
                </div>
                <div className="usage-applications">
                  <h4 className="usage-title">Usage Applications:</h4>
                  <div className="usage-grid">
                    <span className="usage-item">Kabaddi</span>
                    <span className="usage-item">Martial Arts</span>
                    <span className="usage-item">Karate</span>
                    <span className="usage-item">Taekwondo</span>
                    <span className="usage-item">Jiu Jitsu</span>
                    <span className="usage-item">Wrestling</span>
                    <span className="usage-item">Kindergarten</span>
                    <span className="usage-item">General Exercise</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Artificial Turf Cricket */}
            <div className="product-card artificial-turf">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=100&h=100&fit=crop&crop=center" alt="Artificial Turf" />
                </div>
                <h3 className="product-title">Artificial Turf Cricket</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  ELITE INTERNATIONAL offers a true surface with realistic turn and bounce to help take your game to the next level. Perfect for all-weather cricket surfaces when natural wickets are not feasible.
                </p>
                <div className="turf-benefits">
                  <h4 className="turf-title">Key Benefits:</h4>
                  <ul className="turf-list">
                    <li>Realistic turn and bounce characteristics</li>
                    <li>All-weather playing surface</li>
                    <li>Continuous play capability</li>
                    <li>Ideal for training and skills development</li>
                    <li>Perfect for schools and cricket grounds</li>
                    <li>Flat and free-draining surface</li>
                    <li>Unpredictable weather resistant</li>
                  </ul>
                </div>
                <div className="turf-applications">
                  <h4 className="applications-title">Applications:</h4>
                  <div className="applications-grid">
                    <span className="application-item">Match Play</span>
                    <span className="application-item">Practice Nets</span>
                    <span className="application-item">Indoor Training</span>
                    <span className="application-item">Bowlers Run-ups</span>
                    <span className="application-item">Batting Cages</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Facilities Showcase */}
      <section className="facilities-showcase">
        <div className="container">
          <h2 className="section-title">Our Sports Facilities</h2>
          <div className="facilities-grid">
            <div className="facility-item">
              <div className="facility-image basketball-court"></div>
              <h4 className="facility-name">Basketball Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image tennis-court"></div>
              <h4 className="facility-name">Tennis Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image running-track"></div>
              <h4 className="facility-name">Running Tracks</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image football-field"></div>
              <h4 className="facility-name">Football Fields</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image volleyball-court"></div>
              <h4 className="facility-name">Volleyball Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image badminton-court"></div>
              <h4 className="facility-name">Badminton Courts</h4>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. 
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 123 Sports Avenue, Athletic District, City 12345</div>
                <div className="contact-item">📞 0123-456-789</div>
                <div className="contact-item">✉️ info@askmesportsalliance.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="/assets/main logo.png" alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ELITE INTERNATIONAL SPORTS</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 Elite International Sports. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ServicesPage;